import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { isString } from "lodash";
import "./Heading.scss";

export function toDetailString(detail: any) {
  const detailString = typeof detail === "string" ? detail : "";

  if (detailString.trim().length > 0) return ` / ${detailString}`;
  return "";
}

interface HeadingProps {
  title: string;
  details?: string | object;
  beta?: boolean;
}

const getTitle = ({ title, details }: HeadingProps) => {
  let prefixTitle = "";

  if (title) {
    prefixTitle = `${title}${isString(details) ? details : ""} - `;
  }

  return `${prefixTitle}Texada`;
};

const Heading: React.FC<HeadingProps> = ({ title, details, beta }) => {
  const headerContent = document.querySelector("#header-content");

  useEffect(() => {
    document.title = getTitle({ title, details });
  }, [title, details]);

  return headerContent
    ? createPortal(
        <div className="header-container">
          <span className="header-title">{title}</span>
          {beta && <span className="header-title-beta">Beta</span>}
          {details && <span className="header-title-details">{details}</span>}
        </div>,
        headerContent
      )
    : null;
};

export default Heading;
